/**
 * react-select grouped options for the wizard's product dropdown.
 *
 * Managed products appear first under a label that says what picking one
 * does, so a 30-second reach into the customer's ServiceNow is never a
 * surprise. Options carry managedProductId; the wizard uses its presence to
 * decide between the scan flow and the existing manual flow.
 */
export function buildProductGroups(managedProducts, productOptions) {
  const inventory = (managedProducts || [])
    .filter(mp => !mp.isDisabled)
    .map(mp => ({ value: `mp:${mp.id}`, label: mp.name, managedProductId: mp.id }));

  const groups = [];
  if (inventory.length) {
    groups.push({ label: 'Your inventory · scans ServiceNow for live versions', options: inventory });
  }
  groups.push({ label: 'All products', options: productOptions || [] });
  return groups;
}
